import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

export const Section = styled.section`
  width: 100%;
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'transparent')};

  ${props =>
    props.py &&
    css`
      padding-top: ${props.py}px;
      padding-bottom: ${props.py}px;
    `}

  ${props =>
    props.pt &&
    css`
      padding-top: ${props.pt}px;
    `}

  ${props =>
    props.pb &&
    css`
      padding-bottom: ${props.pb}px;
    `}

  ${props =>
    props.mt &&
    css`
      margin-top: ${props.mt}px;
    `}

  ${props =>
    props.mb &&
    css`
      margin-bottom: ${props.mb}px;
    `}
`;

Section.defaultProps = {
  py: null,
  pt: null,
  pb: null,
  mt: null,
  mb: null
};

Section.propTypes = {
  py: PropTypes.number,
  pt: PropTypes.number,
  pb: PropTypes.number,
  mt: PropTypes.number,
  mb: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/styles/Section.js